<template>
  <button :disabled="disabled || false" @click="$emit('cta-click')">
    <slot />
  </button>
</template>

<script>
export default {
  name: "CtaButton",
  props: ["disabled"]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
button {
  font-family: var(--font-brand);
  background-color: var(--primary-green);
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 22px;
  font-weight: bold;
  padding: 15px 10px;
  text-transform: var(--text-transform);
  margin: 30px 0px;
  width: 100%;

  &:hover {
    background-color: var(--primary-darkgreen);
  }

  &[disabled] {
    cursor: default;
    background-color: #9d9d9d;
    color: rgba(255, 255, 255, 0.95);
  }
}
</style>
